/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';

import { AngularFireAuth } from '@angular/fire/compat/auth';
import { delay, filter, pairwise, withLatestFrom } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

// Things that could cause this to fire
// - explicit logout (otherwise handled)
// - nuking the auth indexDB entry
// - resetting the browser while the page is open
// - extreme firebase auth event like the user's auth record being modified elsewhere
// - (most interesting) auth identity provider revoking access and the refresh token failing to validate
// If nothing is done the user will still be "in the app" with various things still partially loaded
// many things broken, and theoretically no access to actually change anything in the rtdb.

@Injectable({ providedIn: 'root' })
export class AuthLostMonitor {
	constructor(private auth: AngularFireAuth) {
		// this.start();
	}

	private _disabled$ = new BehaviorSubject(false);

	/** this service must be explicitly started */
	public start() {
		this.auth.user
			.pipe(
				pairwise(),
				//an alternative behavior would be to complete the observable when disabled emits
				//not doing that just in case we ever need to support re-enabling
				withLatestFrom(this._disabled$),
				filter(([pair, disabled]) => !disabled && pair[0] && !pair[1]),
				//a 500ms delay to allow for sync or "near sync" cleanup before the auto reload
				delay(500)
			)
			.subscribe((__) => {
				window.location.reload();
			});
	}

	/**
	 * disable the auto reload for the rest of the session
	 * use when handling the reload manually by calling before user goes null
	 */
	public disable() {
		this._disabled$.next(true);
	}
}
